import { HttpAdapter } from "../../main/adapters/HttpAdapter";

/**
 * Assinatura HMAC do usuário logado para o chat de atendimento (Chatwoot).
 * O back assina o id que vem do token; não há parâmetro, ninguém pede a assinatura de outro.
 */
export class ChatIdentity {
    HttpAdapter = new HttpAdapter();
    baseUrl = `${publicSettings.aws.baseUrls.usersManagement}/users`;

    async chatIdentity() {
        return await this.HttpAdapter.call(`${this.baseUrl}/chat-identity`, {});
    }
}
